import { axiosV2 } from 'interceptors/axios';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

export const getPartnerUsufructData =
  (partnerId: string) => async (dispatch: any) => {
    const query = { params: { partnerId } };

    try {
      const { data } = await axiosV2.get('/partners/usufructData', query);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
